import { ReactComponent as StatusReadyIcon } from '../../../../../icons/check-green-icon.svg';
import { useIntl } from 'react-intl';
import Dot from '../../components/Dot';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../store/selectors/products';

const Status = () => {
  const { formatMessage } = useIntl();
  const { data } = useSelector(selectProduct);
  const { isActive } = data;

  const status = isActive && <StatusReadyIcon />;
  const statusLabel = isActive ? 'Integration active' : 'Integration inactive';

  return (
    isActive && (
      <div className='integration__status'>
        <Dot size='small'>{status}</Dot>

        <span>{formatMessage({ id: statusLabel })}</span>
      </div>
    )
  );
};

export default Status;
